import Select from "react-select";
import { Input } from "reactstrap";
import React from "react";
import { AppSwitch } from "@coreui/react";

export const renderEditableInput = (prefix, prop, isEditable, onChangeMethod, type, cellInfo) => {
  prefix = prefix.replace("$", cellInfo.index);
  if (isEditable) {
    return (
      <Input
        type={type}
        value={cellInfo.value}
        onChange={value => {
          onChangeMethod([{ prop: prefix + prop, value: value.target.value }, { prop: prefix + "edited", value: true }]);
        }}
        className="w-100"
      />
    );
  } else {
    return <div>{cellInfo.value}</div>;
  }
};

export const renderEditableBoolean = (prefix, prop, isEditable, onChangeMethod, cellInfo) => {
  prefix = prefix.replace("$", cellInfo.index);
  if (isEditable) {
    return (
      <AppSwitch
        className={"mx-1"}
        variant={"pill"}
        color={"faiz1"}
        onChange={e => {
          let value = "";
          e.target.checked ? (value = "1") : (value = "0");
          onChangeMethod([{ prop: prefix + prop, value }, { prop: prefix + "edited", value: true }]);
        }}
        checked={cellInfo.value === "1"}
      />
    );
  } else {
    return <div>{cellInfo.value === "1" ? "Yes" : "No"}</div>;
  }
};

export const renderEditableSelect = (
  prefix,
  prop,
  isEditable,
  onChangeMethod,
  optionsList,
  labelKey,
  valueKey,
  extraPropArray = [],
  cellInfo
) => {
  prefix = prefix.replace("$", cellInfo.index);
  if (isEditable) {
    return (
      <div>
        <Select
          // name="form-field-name"
          value={cellInfo.original[prop]}
          options={optionsList}
          clearable={false}
          getOptionLabel={data => {
            return data.name;
          }}
          getOptionValue={data => {
            return data.id;
          }}
          onChange={value => {
            extraPropArray.push({ prop: prefix + prop, value: value });
            extraPropArray.push({ prop: prefix + "edited", value: true });
            onChangeMethod(extraPropArray);
          }}
        />
      </div>
    );
  } else {
    return <div>{cellInfo.value}</div>;
  }
};

export const toggleSelectTable = (key, selection, deletePropAction, mergePropAction, prop, value) => {
  // start off with the existing state
  const keyIndex = selection.hasOwnProperty(value);
  // check to see if the key exists
  if (keyIndex) {
    // it does exist so we will remove it using destructing
    deletePropAction(prop + value);
  } else {
    // it does not exist so add it
    mergePropAction(prop + value, key);
  }
};

export const toggleSelectAll = (selectAllFlag, currentRecords, updatePropAction, prop) => {
  let selection = {};
  if (!selectAllFlag) {
    // we just push all the IDs onto the selection array
    currentRecords.forEach(item => {
      selection[item.checkbox.id] = item.checkbox;
    });
  }
  updatePropAction([
    { prop: prop, value: selection },
    {
      prop: "selectAll",
      value: !selectAllFlag
    }
  ]);
};

export const isSelected = (key, selection) => {
  return selection.includes(key);
};

export * from "./reactUtilities";
